exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".skip-forward-slow {\n  grid-area: skip-forward-slow;\n}\n\n.skip-forward-fast {\n  grid-area: skip-forward-fast;\n}\n\n.skip-backward-slow {\n  grid-area: skip-backward-slow;\n}\n\n.skip-backward-fast {\n  grid-area: skip-backward-fast;\n}", ""]);

